<script>
  import { _ } from "svelte-i18n";
</script>


<section class="text-gray-600 body-font">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-col text-center w-full mb-20">
        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">{$_("brands.list", {
          default: "le nostre marche",
        })}</h1>
        <p class="lg:w-2/3 mx-auto leading-relaxed text-base"></p>
      </div>
         <div class="flex flex-wrap -m-2">

        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg ">
            <img alt="baf" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/baf.jpg">
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium ml-10"><b> BAF  - Brackett Aero Filters </b></h2>
              <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Air filters </i></h3>
            </div>
          </div>
        </div>

        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg ">
              <img alt="champion" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/champion.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Champion Aerospace </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Ignition Products </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="concorde" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Concorde.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Concorde </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Batteries </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="continental" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/continental.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Continental Aereospace </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Engines, Cylinders & Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="general" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/general.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> General Electric </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Lighting </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="gill" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/gill.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Gill - Teledyne Battery Products </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Batteries </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="goodyear" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/goodyear.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Goodyear Corporate </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Tyres & Tubes </i></h3>
              </div>
            </div>
          </div>

        
          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="lycoming" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/lycoming.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Lycoming </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Engynes, Cylinders & Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="michelin" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/michelin.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Michelin </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Tyres & Tubes </i></h3>
              </div>
            </div>
          </div>
          
          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="parker" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/parker.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Parker Aerospace - Cleveland </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft, Wheels & Brakes </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="piper" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/piper.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Piper </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Airframe Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="rapco" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/rapco.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Rapco </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Replacement Aircraft Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="aeroshell" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/shell.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Aeroshell </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Oil & Grease </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="tempest" class="ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/tempest.jpg" images >
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Tempest </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Electrical & Pneumatic Components </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="timken" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/timken.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Timken </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Wheel Bearings </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Acf" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/ACF.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Acf-50 </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Corrosion Inhibitor </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Aps" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/aps.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Aps </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Brake Disk, Linings & Rivets </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Barry" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Barry.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Barry Controls </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Shock Mounts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Cessna" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Cessna.gif">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b>Cessna Aircraft </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Airframe Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="H3r" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/H3R.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> H3R Aviation </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Halon Fire Extinguishers </i></h3>
              </div>
            </div>
          </div>
      

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Kelly" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Kelly.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Kelly Aerospace </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Magnetos & Harnesses </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Janitrol" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/janitrol.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Janitrol Aero </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Het Cabin Heaters </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Lamar" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Lamar.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Lamar Technologies </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Electrical Controls & Components </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Lord" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Lord.jpg">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Lord Corporation </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Shock Mounts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Lps" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/LPS.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> LPS Chemical Products </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Lubrificants & Cleaners </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="McFarlane" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/McFarlane.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> McFarlane </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Replacement Aircraft Parts </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Sky-Tec" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Sky-Tec.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Sky-Tec </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Light Starter Motors </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Superior" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Superior.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Superior Air Parts </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Replacement Part </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Weldon" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Weldon.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Weldon Aerospace </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Fuel Pumps </i></h3>
              </div>
            </div>
          </div>

          <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
              <img alt="Weldon" class=" ml-5 w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src="images/Whelen.png">
              <div class="flex-grow">
                <h2 class="text-gray-900 title-font font-medium ml-10"><b> Whelen Engineering </b></h2>
                <h3 class="text-gray-500 subtitle-font font-small ml-10"><i> Aircraft Lighting </i></h3>
              </div>
            </div>
          </div>

    </div>
    </div>
  </section>